import cn from 'classnames';
import { Typography } from 'seagull';
import styles from "./TabPimple.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TabPimple(_ref) {
  let {
    count,
    className
  } = _ref;
  if (isNaN(count) || 0 >= count) return null;
  const content = count >= 9 ? '9+' : String(count);
  return /*#__PURE__*/_jsx("div", {
    className: cn(styles.root, className),
    children: /*#__PURE__*/_jsx(Typography, {
      skin: "invertedStandard",
      as: "span",
      className: styles.pimple,
      "aria-label": "".concat(content, " notifications"),
      testId: "pimple",
      children: count >= 9 ? '9+' : String(count)
    })
  });
}